module.exports = __webpack_public_path__ + "static/media/hall-P2.d34c55d2.svg";